import $ from 'jquery';

import type { AdditionalValidatorOptions } from '#public_ts/components';
import { useValidator as useBaseValidator } from '#public_ts/composables';

import type { ProductFormData, ProductFormState } from './types';

export function useValidator(formData: ProductFormData, formState: ProductFormState) {
    // if controls desn't exists - rule is unused
    function setupValidator() {
        $.validator.addMethod('promotion', function(value, element) {
            return this.optional(element) || (formState.isPromotionCodeValid === true);
        }, () => {
            const message = formState.isPromotionCodeValid;
            if(!message || (message === true)) return 'Codice promozione non valido';
            return message;
        });

        $.validator.addMethod('activation', function(value, element) {
            return this.optional(element) || (formState.isPromotionCodeValid === true);
        }, 'Codice di attivazione non valido');

        $.validator.addMethod('user_discount_code', function(value, element) {
            return this.optional(element) || (formState.isUserDiscountCodeAvailable !== false);
        }, 'Codice di sconto non univoco');

        $.validator.addMethod('require_company_type', () => {
            const company_type = $(
                '#company_type_0,#company_type_1,#company_type_2,#company_type_3,#company_type_4,#company_type_5,.checkbox-category-cliente',
            );
            let valid = false;
            if(!valid) {
                const checked = company_type.filter(':checked').length == 1;
                if(checked) valid = true;
            }
            if(!valid) {
                // vue sync
                const checked = [formData.company_type_0,
                    formData.company_type_1,
                    formData.company_type_2,
                    formData.company_type_3,
                    formData.company_type_4,
                    formData.company_type_5].filter(Boolean).length == 1;
                if(checked) valid = true;
            }

            return valid;
        }, 'Seleziona 1 di questi campi.');

        const rules: Exclude<AdditionalValidatorOptions['rules'], undefined> = {
            'Product_Quantity': { required: true, digits: true, min: 1 },
            'Product_Promotion_Code': { promotion: true, upcase: { numbers: true } },

            'codice_destinatario': { required: true, destinatario: { b2b: true } },

            'Name': { required: true, rangelength: [1, 60] },
            'Surname': { required: true, rangelength: [1, 60] },
            'Title': { rangelength: [2, 10] },
            'Personal_Email': { required: true, email: true, rangelength: [7, 256] },
            'Personal_cel': { rangelength: [5, 12] },
            'Company_Name': { required: true, rangelength: [1, 80] },
            'Company_address': { required: true, rangelength: [1, 60] },
            'Company_PostIndex': { required: true, cap: true, rangelength: [1, 10] },
            'Company_City': { required: true, rangelength: [1, 60] },
            'Company_Province': { required: true, upcase: true, rangelength: [2, 2] },
            'Company_Tax_Number': { required: true, IVAorCF: true },
            'Company_Fiscal_Code': { required: false, IVAorCF: true },

            'Service_FE_send_email_flag': {},
            'Service_FE_send_email': { required: true, email: true },
            'Service_FE_send_email_2': { required: false, email: true },

            'Regolamento_flag': { required: true },
            'Regolamento_Assistenza_flag': { required: true },
            'ConvenzioneDiServizio_flag': { required: true },
            'Privacy_flag': { required: true },
            'Privacy_flag_2': {},

            'privacy_marketing_ours_on': { require_from_group: [1, '#privacy_marketing_ours_on,#privacy_marketing_ours_off'] },
            'privacy_marketing_ours_off': { require_from_group: [1, '#privacy_marketing_ours_on,#privacy_marketing_ours_off'] },

            'privacy_marketing_group_on': { require_from_group: [1, '#privacy_marketing_group_on,#privacy_marketing_group_off'] },
            'privacy_marketing_group_off': { require_from_group: [1, '#privacy_marketing_group_on,#privacy_marketing_group_off'] },

            'privacy_marketing_profilazione_on': { require_from_group: [1, '#privacy_marketing_profilazione_on,#privacy_marketing_profilazione_off'] },
            'privacy_marketing_profilazione_off': { require_from_group: [1, '#privacy_marketing_profilazione_on,#privacy_marketing_profilazione_off'] },

            // AR: Should be selected only one of checkboxes below
            'company_type_1': { require_company_type: true },
            'company_type_2': { require_company_type: true },
            'company_type_3': { require_company_type: true },
            'company_type_4': { require_company_type: true },
            'company_type_5': { require_company_type: true },

            'Professional_Type_1': { required: true },
            'Professional_Type_2': { required: true },
        };

        const baseValidator = useBaseValidator({
            rules,
        });
        const errorPlacement = baseValidator.errorPlacement as (error: JQuery, element: JQuery) => void;
        return {
            ...baseValidator,
            useValidatorDefaults: false as const,
            errorPlacement(error, element) {
                let parent = element.parent();
                if(parent.is('dd.d-inline')) {
                    parent = parent.parent();
                    error.appendTo(parent);
                    return;
                }
                errorPlacement(error, element);
            },
        };
    }
    const validator = setupValidator();

    return {
        validator,
    };
}
